
import Gutter from '@/ui-kit/components/gutter';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
} from '@/ui-kit/styles/enums';
import { FilterType } from '@/components/filters/enums';
import FilterPropertyTypes from '@/components/filters/property-types';
import FilterBeds from '@/components/filters/beds';
import FilterBaths from '@/components/filters/baths';
import FilterPrice from '@/components/filters/price';
import FilterMore from '@/components/filters/more';
import { FilterMoreDefaultFilters } from '@/components/filters/more/enums';
import SearchFiltersEvents from '../../mixins/SearchFiltersEvents';

export default {
  name: 'SearchFiltersDesktop',
  components: {
    Gutter,
    FilterMore,
    FilterPropertyTypes,
    FilterBeds,
    FilterBaths,
    FilterPrice,
  },
  mixins: [SearchFiltersEvents],
  props: {
    filters: {
      default: () => ({}),
      type: Object,
    },
    resetButtonText: {
      required: true,
      type: String,
    },
    submitButtonText: {
      required: true,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      FilterType,
      FilterMoreDefaultFilters,
    };
  },
  computed: {
    filterMoreValues() {
      return FilterMoreDefaultFilters.reduce((acc, filterType) => ({
        ...acc, [filterType]: this.filters[filterType],
      }), {});
    },
  },
  methods: {
    changeFilter(filterType, value) {
      this.trackFilterChange(filterType, value);
      this.emitChange({ ...this.filters, [filterType]: value });
    },
    handlePropertyTypeFilterChange(value) {
      this.changeFilter(FilterType.BuildingClass, value);
    },
    handlePriceFilterChange(value) {
      this.changeFilter(FilterType.Price, value);
    },
    handleBedsFilterChange(value) {
      this.changeFilter(FilterType.Beds, value);
    },
    handleBathsFilterChange(value) {
      this.changeFilter(FilterType.Baths, value);
    },
    handleChangeMoreFilter({ key, value }) {
      this.changeFilter(key, value);
    },
  },
};
